export default "__VITE_ASSET__BFyAvK5h__"